import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import api from "@/app/api";
import type { StockLocation } from "@/app/services/generated/stocklocationService";
import { stockLocationService } from "@/app/services/generated/stocklocationService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasStockLocationsCache {
  stockLocations: StockLocationsCache;
}

// Singleton cache store
const stockLocationsCacheStore = new EntityCacheStore<StockLocation>(
  EnumCacheEntityType.stockLocation,
  async () => stockLocationService.getAllStockLocations(api.tenantId)
);

// Ephemeral reader
export default class StockLocationsCache extends EntityWithGuidKeyCache<StockLocation> {
  constructor() {
    super(stockLocationsCacheStore, (x) => x.id);
  }

  public getDefault(): StockLocation | null {
    return this.all.find((x) => x.isDefault) ?? null;
  }

  public getProductionDefault(): StockLocation | null {
    return this.all.find((x) => x.isDefaultForProduction) ?? null;
  }

  public resolveRequiredStockLocationForAssembly(): StockLocation {
    return (
      this.getProductionDefault() ??
      this.getDefault() ??
      this.all.filter(
        (stockLocation) => !stockLocation.isExternal && !stockLocation.isHidden
      )[0]
    );
  }

  public get notExternal(): readonly StockLocation[] {
    return this.all.filter((stockLocation) => !stockLocation.isExternal);
  }

  public get notHidden(): readonly StockLocation[] {
    return this.all.filter((stockLocation) => !stockLocation.isHidden);
  }
}
